import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, ordersPendingForExchangeActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, ordersPendingForExchangeActions);

export default slice.reducer;
